const tipos = {
  SIMPLES: '1',
  GRADE: '2',
  PIZZA: '3',
  MATERIA_PRIMA: '4',
};

export default tipos;
